import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonDropdownSearchComponent } from '../common-component-dropdown-search/common-component-dropdown-search.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { SharedValidators } from '../shared/validators/shared-validators';
@Component({
  selector: 'app-ota-master',
  templateUrl: './ota-master.component.html',
  styleUrls: ['./ota-master.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatIcon,
    MatTooltip,
    MatOption,
    MatSelect,
    NgxPaginationModule,
    CommonSearchComponent,
    CommonPaginationComponent,
    CommonDropdownSearchComponent,
  ],
})
export class OtaMasterComponent implements OnInit {
  page = 1;
  size = 10;
  totalLength = 0;
  searchString = '';
  filterSelect = '';

  otaMaster: FormGroup = this.formBuilder.group({});
  filterForm: FormGroup = this.formBuilder.group({});

  createOta = false;
  updateOta = false;
  deleteOta = false;
  otaMasterView = false;
  addNewOta = false;

  AddOtaItemBtn = true;
  UpdateOtaItem = false;

  userPermission = [];
  loggedId = '';

  InputFields = ['YES', 'NO'];
  otaTypeList = ['GET', 'SET', 'CLR'];

  index: any;
  UpdateIndexData: any = {};
  updatePayload: any = {};

  otaItems = [];

  otaOverviewFilter = [
    { key: 'All', value: 'All' },
    { key: 'GET', value: 'GET' },
    { key: 'SET', value: 'SET' },
    { key: 'CLR', value: 'CLR' },
  ];

  constructor(
    public formBuilder: FormBuilder,
    public apiMicroservice: ApiServiceService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.setOtaMasterForm();
    this.checkPermission();
    if (this.otaMasterView) {
      this.fetchOtaMaster();
    }
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.loggedId = this.apiMicroservice.decryptData(
      sessionStorage.getItem('userRefId') || ''
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'OTA Master' && element.view === false) {
          this.navigateBack();
        }
        if (element.pageName === 'OTA Master' && element.view === true) {
          this.otaMasterView = true;
        }
        if (element.pageName === 'OTA Master' && element.delete === true) {
          this.deleteOta = true;
        }
        if (element.pageName === 'OTA Master' && element.create === true) {
          this.createOta = true;
        }
        if (element.pageName === 'OTA Master' && element.update === true) {
          this.updateOta = true;
        }
      }
    );
  }

  setOtaMasterForm() {
    this.otaMaster = this.formBuilder.group({
      example: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      name: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      otaType: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      otaCommand: new FormControl(
        '',
        SharedValidators.requiredAndNoEmptySpaces
      ),
      timeInMs: new FormControl('10000', Validators.required),
      isInputRequired: new FormControl(
        '',
        SharedValidators.requiredAndNoEmptySpaces
      ),
    });
    this.filterForm = this.formBuilder.group({
      filterSelected: new FormControl(''),
    });
  }

  fetchOtaMaster() {
    this.spinner.show();

    this.apiMicroservice
      .getOtaCommandList(
        this.page,
        this.size,
        this.searchString,
        this.filterSelect
      )
      .subscribe({
        next: (res) => {
          this.otaItems = res.data;
          this.totalLength = res.count;
          this.spinner.hide();
        },
        error: (err) => {
          this.apiMicroservice.openSnackbar(err.message);
          this.otaItems = [];
          this.spinner.hide();
        },
      });
  }

  getIndex(index: number, page: number, size: number): number {
    return index + (page - 1) * size;
  }

  filterSelected(event: string) {
    this.page = 1;
    this.filterSelect = event;
    this.fetchOtaMaster();
  }

  onPageChange(event: number) {
    this.page = event;
    this.fetchOtaMaster();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.fetchOtaMaster();
  }

  onSearch(event: string) {
    this.page = 1;
    this.searchString = event;
    this.filterForm
      ?.get('filterSelected')
      ?.setValue(this.searchString ? this.searchString : '');
    this.fetchOtaMaster();
  }

  updateCommandList() {
    this.spinner.show();

    let request;

    if (this.updatePayload._id) {
      // UPDATE
      request = this.apiMicroservice.updateOtaCommand(
        this.updatePayload._id,
        this.updatePayload
      );
    } else {
      // CREATE
      request = this.apiMicroservice.createOtaCommand(this.updatePayload);
    }

    request.subscribe({
      next: (res) => {
        this.spinner.hide();
        this.apiMicroservice.openSnackbar(res.message);
        this.cancelFunc();
        this.fetchOtaMaster();
      },
      error: (err) => {
        this.spinner.hide();
        console.error(err);
        this.apiMicroservice.openSnackbar(err.error.message);
        this.fetchOtaMaster();
      },
    });
  }

  submit() {
    const payLoadData = this.otaMaster.value;
    if (this.otaMaster.valid) {
      this.updatePayload = {
        ...payLoadData,
        isInputRequired: payLoadData.isInputRequired === 'YES',
        loggedId: this.loggedId,
      };
      this.updateCommandList();
    } else {
      SharedValidators.markAllAsTouched(this.otaMaster);
    }
  }

  otaFormFill(index: number) {
    if (index) {
      this.updateData(index);
    } else {
      this.addNewOTACommandFunc();
    }
  }

  updateData(index: number) {
    this.AddOtaItemBtn = false;
    this.UpdateOtaItem = true;
    this.addNewOta = true;
    this.index = index;
    const indexNew = this.getIndex(index, this.page, this.size);
    this.UpdateIndexData = this.otaItems[indexNew];

    this.otaMaster = this.formBuilder.group({
      example: new FormControl(
        this.UpdateIndexData.example,
        SharedValidators.requiredAndNoEmptySpaces
      ),
      name: new FormControl(
        this.UpdateIndexData.name,
        SharedValidators.requiredAndNoEmptySpaces
      ),
      otaType: new FormControl(
        this.UpdateIndexData.otaType,
        SharedValidators.requiredAndNoEmptySpaces
      ),

      otaCommand: new FormControl(
        this.UpdateIndexData.otaCommand,
        SharedValidators.requiredAndNoEmptySpaces
      ),
      timeInMs: new FormControl(
        this.UpdateIndexData.timeInMs,
        Validators.required
      ),

      isInputRequired: new FormControl(
        this.UpdateIndexData.isInputRequired ? 'YES' : 'NO',
        SharedValidators.requiredAndNoEmptySpaces
      ),
    });
  }

  updateItem() {
    const payLoadData = this.otaMaster.value;
    if (this.otaMaster.valid) {
      this.updatePayload = {
        ...this.UpdateIndexData,
        ...payLoadData,
        isInputRequired: payLoadData.isInputRequired === 'YES',
        loggedId: this.loggedId,
      };
      this.updateCommandList();
    } else {
      SharedValidators.markAllAsTouched(this.otaMaster);
    }
  }

  resetForm() {
    this.otaMaster.markAsUntouched();
    this.otaMaster = this.formBuilder.group({
      example: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      name: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      otaType: new FormControl('', SharedValidators.requiredAndNoEmptySpaces),
      otaCommand: new FormControl(
        '',
        SharedValidators.requiredAndNoEmptySpaces
      ),
      timeInMs: new FormControl('10000', Validators.required),
      isInputRequired: new FormControl(
        '',
        SharedValidators.requiredAndNoEmptySpaces
      ),
    });
    this.AddOtaItemBtn = true;
    this.UpdateOtaItem = false;
  }

  deleteCommand(item: { _id: string }) {
    if (confirm('Do you want to delete this OTA Command?')) {
      this.spinner.show();

      this.apiMicroservice.deleteOtaCommand(item._id).subscribe({
        next: (res) => {
          this.spinner.hide();
          this.apiMicroservice.openSnackbar(
            res.message || 'OTA Command Deleted successfully'
          );
          this.fetchOtaMaster();
        },
        error: (err) => {
          this.spinner.hide();
          console.error(err);
          this.apiMicroservice.openSnackbar(
            err.error?.message || 'Delete failed'
          );
        },
      });
    }
  }

  // Show add OTA form
  addNewOTACommandFunc() {
    this.addNewOta = true;
    this.index = '';
    this.resetForm();
  }

  // Cancel and hide add/edit form
  cancelFunc() {
    this.addNewOta = false;
    this.index = '';
    this.resetForm();
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
